import React, { Component } from "react";
import Scroll from "scroll-js/dist/scroll";

import {
  Nav,
  Navbar,
  NavItem,
  NavLink,
  NavbarToggler,
  Button,
  Collapse
} from "reactstrap";
import Portfolio from "../../pages/Home/Portfolio";

const scrollTo = event => {
  const scroll = new Scroll(document.body);
  event.preventDefault();
  const target = event.target.text.toLowerCase();
  if (target === "our approach") {
    const targetElement = document.querySelector(".home--approach");
    scroll.toElement(targetElement, { duration: 500 });
  } else if (target === "about") {
    const targetElement = document.querySelector(".home--about");
    scroll.toElement(targetElement, { duration: 500 });
  } else if (target === "projects") {
    const targetElement = document.querySelector(".home--portfolio");
    scroll.toElement(targetElement, { duration: 500 });
  } else if (target === "contact") {
    const targetElement = document.querySelector(".home--contact");
    scroll.toElement(targetElement, { duration: 500 });
  }
};

export default class Header extends Component {
  state = {
    collapsed: false
  };

  toggle = () => {
    console.info("toggle");
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const pages = ["Our Approach", "About", "Projects", "Contact"];
    return (
      <Navbar expand="md" fixed="top">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img
              src="/images/inclusiveLabs-logo.png"
              width="200px"
              height="auto"
            />
            {"  "}
            <Button outline color="#fd4f59" className="beta" disabled>
              BETA
            </Button>{" "}
          </a>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.collapsed} navbar>
            <Nav className="ml-auto" navbar>
              {/* <li className="nav-item active">
            <a className="nav-link" href="/">
              Home <span className="sr-only">(current)</span>
            </a>
          </li>
          */}
              {pages.map(page => (
                <NavItem>
                  <NavLink onClick={scrollTo}>{page}</NavLink>
                </NavItem>
              ))}

              {/* <Form className="form-inline my-2 my-md-0">
          <Input
            className="form-control"
            type="text"
            placeholder="Search"
            aria-label="Search"
          />
        </Form> */}
            </Nav>
          </Collapse>
        </div>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js